import { protectedDocumentUrl } from "../services/tenantDocuments";
import apis from "@/apis";
import * as _ from "lodash";
import axios from "axios";
import { uploadApplicantDocument } from "../services/documentUpload";
import { TENANCY_ENABLED } from "../services/tenant";
import store from "../store";
import * as jspdf from "jspdf";

export default {
    getErrorMessage(error, fallback) {
        const body = error && (error.response ? error.response.data : error.body);
        const detail = typeof body === "string" ? body :
            body && (body.message || body.Message || body.title);
        if (typeof detail === "string" && detail.trim() && !/<[^>]+>/.test(detail)) {
            return detail;
        }
        const status = error && (error.response ? error.response.status : error.status);
        if (status) return fallback + " (HTTP " + status + ").";
        return error && error.message ? error.message : fallback;
    },
    async onFileChange(files, filename) {
        const file = files && (files.name ? files : files[0]);
        if (!file || typeof file.name !== "string") {
            return { status: false, message: "Please select a file to upload." };
        }
        const extn = file.name.split(".").pop().toLowerCase();
        if (["jpeg", "png", "jpg", "pdf"].indexOf(extn) === -1) {
            return { status: false, message: "Please select a JPEG, JPG, PNG or PDF file." };
        }
        if (!file.size) {
            return { status: false, message: "The selected file is empty." };
        }
        const userinfo = store.getters.loggedUser;
        if (!userinfo || !userinfo.UserId || !store.getters.authToken) {
            return { status: false, message: "Your session has expired. Please sign in again." };
        }
        const filepath = filename + extn;
        try {
            let response;
            if (TENANCY_ENABLED) {
                response = await uploadApplicantDocument(userinfo.UserId, filepath, file);
            } else {
                const data = new FormData();
                data.append("file", file, userinfo.UserId + "!!~~!!" + filepath);
                response = await axios.post(
                    "https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter",
                    data, {
                        headers: { Authorization: "Bearer " + store.getters.authToken }
                    }
                );
            }
            if (response.status < 200 || response.status >= 300) {
                throw new Error("File upload failed (HTTP " + response.status + ").");
            }
            return { status: true, message: filepath };
        } catch (error) {
            console.error("Document upload failed:", error);
            return {
                status: false,
                message: this.getErrorMessage(error, "Unable to upload the file. Please try again.")
            };
        }
    },

    getImgUrl(pic) {
        if (pic) {
            if (pic.split(".").pop() == "pdf") {
                return require("@/assets/Pdf.jpg");
            }

            var userinfo = store.getters.loggedUser;
            var userid = userinfo.UserId;
            return (
                protectedDocumentUrl("https://aws.msobcfdc.in/S3BucketApril/" +
                userid.toLowerCase() +
                "/" +
                pic)
            );
        }
    },
    getImgUrl2(pic) {
        if (pic) {
            var userinfo = store.getters.loggedUser;
            var userid = userinfo.UserId;
            return (
               // "https://aws.msobcfdc.in/S3BucketApril/" +
               protectedDocumentUrl("https://aws.msobcfdc.in/S3BucketApril/" +
                userid.toLowerCase() +
                "/" +
                pic)
            );
        }
    },
}


// WEBPACK FOOTER //
// ./src/apis/common.js